/**
 * Base Algolia Configuration
 */
export const baseConfig = {
  app_id: process.env.ALGOLIA_PRODUCT_ID,
  search_api_key: process.env.ALGOLIA_PRODUCT_KEY,
  index_prefix: 'shopify_',
  index_products: process.env.ALGOLIA_PRODUCT_INDEX,
  index_suggested_keywords: process.env.ALGOLIA_KEYWORD_INDEX,
  index_suggested_categories: process.env.ALGOLIA_CATEGORY_INDEX,
  index_collections: process.env.ALGOLIA_COLLECTIONS_INDEX,
  index_category_order: `${process.env.ALGOLIA_PRODUCT_INDEX}_facets`,
  sort_orders: [
    {
      key: 'price',
      title: 'Price',
      asc: {
        active: true,
        title: 'Price: Low - High',
      },
    },
    {
      key: 'price',
      title: 'Price',
      desc: {
        active: true,
        title: 'Price: High - Low',
      },
    },
    {
      key: 'published_at',
      title: 'Publication date',
      desc: {
        active: true,
        title: 'New - Old',
      },
    },
    {
      key: 'published_at',
      title: 'Publication date',
      asc: {
        active: true,
        title: 'Old - New',
      },
    },
    {
      key: 'title',
      title: 'Name',
      asc: {
        active: true,
        title: 'Title: A - Z',
      },
    },
    {
      key: 'title',
      title: 'Name',
      desc: {
        active: true,
        title: 'Title: Z - A',
      },
    },
    {
      key: 'rating',
      title: 'Rating',
      desc: {
        active: true,
        title: 'Popularity',
      },
    },
  ],
  base_facets: [
    { facet: 'isMarketplace', type: 'toggleRefinement', title: 'Exclude Marketplace products' },
    {
      facet: 'Sold by',
      type: 'refinementList',
    },
    {
      facet: 'Brand',
      type: 'refinementList',
    },
    {
      facet: 'Price',
      type: 'priceRanges',
    },
  ],
  products_autocomplete_hits_per_page: 15,
  collections_autocomplete_hits_per_page: 3,
  articles_autocomplete_hits_per_page: 3,
  instant_search_enabled: true,
  results_selector: '.main-content',
  products_full_results_hits_per_page: 20,
  collections_full_results_hits_per_page: 10,
  show_products: true,
  product_families_index: process.env.ALGOLIA_PRODUCT_FAMILY_INDEX,
  product_families_api_key: process.env.ALGOLIA_PRODUCT_FAMILY_KEY,
};

export const jbConfig = {
  algoliaFaqIndex: process.env.ALGOLIA_FAQ_INDEX,
  algoliaCatIndex: process.env.ALGOLIA_CAT_INDEX,
  algliaStoreLocatorIndex: process.env.ALGOLIA_LOCATION_INDEX,
  algoliaStoreShowOnWeb: 'p',
  algliaStorePostcodeIndex: process.env.ALGOLIA_POSTCODE_INDEX,
};
